exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".scoped-salary-rules{min-height:500px}.scoped-salary-rules .file-upload-tip{padding-top:5px;position:absolute;left:240px;top:-7px;color:#aaa}.scoped-salary-rules .level-tip{color:#aaa;margin-left:30px}.scoped-salary-rules .handler-btns{background:#fbfbfb;padding:30px 80px;border:1px solid #ddd;border-radius:5px}.scoped-salary-rules .rule-salary th{height:30px}.scoped-salary-rules .rule-salary .is-leaf{font-weight:400}.scoped-salary-rules .rule-salary .is-leaf .cell{color:#999}.scoped-salary-rules .upload-desc{width:300px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0d0a7878","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/salary/salayRuleDetail.vue
// module id = 913
// module chunks = 23